<ul #liEvents nz-menu [nzMode]="'inline'" [nzInlineCollapsed]="isCollapsed()"
  >
    <li
      routerLinkActive="ant-menu-item-selected"
      nz-menu-item
    >
      <span nz-icon nzType="unordered-list"></span>
      <span> <a routerLink="/new-questionnaires">Вопросы</a></span>
    </li>
</ul>